import { BlockInterface } from "interfaces/block.interface";
import { PageInterface } from "interfaces/page.interface";

export enum BlocksActionTypes {
  FETCH_BLOCKS_REQUEST = "FETCH_BLOCKS_REQUEST",
  FETCH_BLOCKS_SUCCESS = "FETCH_BLOCKS_SUCCESS",
  FETCH_BLOCKS_FAILURE = "FETCH_BLOCKS_FAILURE",
}

// Action interfaces
export interface FetchBlocksRequestAction {
  type: BlocksActionTypes.FETCH_BLOCKS_REQUEST;
  payload: {
    page: number;
    take: number;
  };
}

export interface FetchBlocksSuccessAction {
  type: BlocksActionTypes.FETCH_BLOCKS_SUCCESS;
  payload: PageInterface<BlockInterface>;
}

export interface FetchBlocksFailureAction {
  type: BlocksActionTypes.FETCH_BLOCKS_FAILURE;
  payload: string;
}

// Action creators
export const fetchBlocksRequest = (
  page: number,
  take: number
): FetchBlocksRequestAction => ({
  type: BlocksActionTypes.FETCH_BLOCKS_REQUEST,
  payload: { page, take },
});

export const fetchBlocksSuccess = (
  data: PageInterface<BlockInterface>
): FetchBlocksSuccessAction => ({
  type: BlocksActionTypes.FETCH_BLOCKS_SUCCESS,
  payload: data,
});

export const fetchBlocksFailure = (
  error: string
): FetchBlocksFailureAction => ({
  type: BlocksActionTypes.FETCH_BLOCKS_FAILURE,
  payload: error,
});

export type BlocksActions =
  | FetchBlocksRequestAction
  | FetchBlocksSuccessAction
  | FetchBlocksFailureAction;
